import React from 'react';
import { StepCard, StepHeader, StepFormContainer } from './PxwStepComponents';
import { REVIEW_TASKS, TenantStepData } from './types';
import { ReviewTaskItem } from './ReviewTaskItem';
import type { TaskStatus } from './usePxwConnectorConfig';

interface ReviewRunStepProps {
  taskStatuses: Record<string, TaskStatus>;
  taskErrors: Record<string, string>;
  onRunTask: (taskId: string) => Promise<boolean> | Promise<void>;
  tenantData: TenantStepData;
}

const ReviewRunStep = ({
  taskStatuses,
  taskErrors,
  onRunTask,
  tenantData,
}: ReviewRunStepProps) => {
  const isTaskEnabled = (taskId: string) => {
    switch (taskId) {
      case 'vanilla':
        return true;
      case 'qbo-configurator':
      case 'qbo-setup':
        return tenantData.configureQuickBooks;
      case 'shipstation':
        return tenantData.configureShipStation;
      case 'diagnostic':
        return tenantData.configureDiagnostic;
      default:
        return true;
    }
  };

  const activeCount = REVIEW_TASKS.filter((t) => isTaskEnabled(t.id)).length;

  return (
    <StepCard>
      <StepHeader
        title="Review & Run"
        subtitle={`${activeCount} API call${activeCount === 1 ? '' : 's'} will run in sequence against the connector maintenance gateway.`}
      />
      <StepFormContainer>
        <div className="small-12">
          {REVIEW_TASKS.map((task) => (
            <ReviewTaskItem
              key={task.id}
              task={task}
              enabled={isTaskEnabled(task.id)}
              status={taskStatuses[task.id] || 'idle'}
              errorMsg={taskErrors[task.id]}
              onRunTask={onRunTask}
              readOnly={(task.id === 'vanilla' || task.id === 'deploy-build') && taskStatuses[task.id] === 'success'}
            />
          ))}
        </div>
      </StepFormContainer>
    </StepCard>
  );
};

export default ReviewRunStep;
